import { Fragment, ReactElement, useMemo } from 'react'
import { PaginationProps } from './props'
import { NextPrevLabel, PageNumber, StyledPagination } from './styles'
import { SVG } from '../../Atoms'

import useStep from '../../Hooks/useStep'
import { usePagination } from './hooks'
import { SVGs } from '../..'

const Pagination = ({
    boundaryCount = 1,
    breakLabel = '...',
    nextLabel = <SVG src={SVGs.ChevronRightCircle} />,
    onPageChange = () => undefined,
    pageCount,
    pageLabel = (currentPage) =>
        pageCount === currentPage ? `${currentPage}` : `${currentPage}`,
    prevLabel = <SVG src={SVGs.ChevronLeftCircle} />,
    siblingCount = 2,
    ...props
}: PaginationProps): ReactElement => {
    const [currentPage, helpers] = useStep(pageCount)

    const pages = usePagination(
        boundaryCount,
        currentPage,
        onPageChange,
        pageCount,
        siblingCount
    )

    const pagesNode = useMemo(
        () =>
            pages.map((page, key) => {
                if (page === 'break') {
                    if (pages[key + 1] === 'break')
                        return <Fragment key={key} />
                    return (
                        <PageNumber key={key} ellipsis>
                            {breakLabel}
                        </PageNumber>
                    )
                }

                return (
                    <PageNumber
                        key={key}
                        onClick={() => helpers.setStep(page)}
                        active={currentPage === page}
                    >
                        {pageLabel(page)}
                    </PageNumber>
                )
            }),
        [breakLabel, currentPage, helpers, pageLabel, pages]
    )

    return (
        <StyledPagination {...props}>
            <NextPrevLabel
                className="rr-prev-label"
                disabled={!helpers.canGoToPrevStep}
                onClick={() => helpers.goToPrevStep()}
            >
                {prevLabel}
            </NextPrevLabel>
            {pagesNode}
            <NextPrevLabel
                className="rr-next-label"
                disabled={!helpers.canGoToNextStep}
                onClick={() => helpers.goToNextStep()}
            >
                {nextLabel}
            </NextPrevLabel>
        </StyledPagination>
    )
}

export default Pagination

export { StyledPagination }
